import { useTranslation } from "react-i18next"
import { Skeleton } from "@/components/ui/skeleton"

/**
 * The form while `getConfig` loads (LLD §9.1 state 1), shaped like it: label
 * and field pairs, then the button, at the real controls' heights (44 px on
 * phones), so the form replaces it without moving the heading above.
 */
export function FormSkeleton({ fields = 2 }: { fields?: number }) {
  const { t } = useTranslation("common")
  return (
    <div className="space-y-4" aria-busy="true" aria-live="polite">
      <span className="sr-only">{t("states.loading")}</span>
      {Array.from({ length: fields }, (_, i) => (
        <div key={i} className="space-y-2">
          <Skeleton className="h-3.5 w-24" />
          <Skeleton className="h-9 w-full max-md:h-11" />
        </div>
      ))}
      <Skeleton className="h-9 w-full max-md:h-11" />
    </div>
  )
}
